/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type CustomPageIcon = typeof CustomPageIcon[keyof typeof CustomPageIcon];


export const CustomPageIcon = {
  FILEICON: 'FILEICON',
  FILEWORDICON: 'FILEWORDICON',
  FILEEXCELICON: 'FILEEXCELICON',
  PAPERPLANEICON: 'PAPERPLANEICON',
  PAPERCLIPICON: 'PAPERCLIPICON',
  PALETTEICON: 'PALETTEICON',
  GLOBEICON: 'GLOBEICON',
  STARICON: 'STARICON',
  CLOUDICON: 'CLOUDICON',
  COMMENTSICON: 'COMMENTSICON',
  KEYICON: 'KEYICON',
  ENVELOPEICON: 'ENVELOPEICON',
  SHIELDICON: 'SHIELDICON',
  LANGUAGEICON: 'LANGUAGEICON',
  CARICON: 'CARICON',
} as const;
